import React, { useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Button, FormControl } from 'react-bootstrap';

import Utils from '../util/Utils.jsx';
import { useStateValue } from '../context/state.jsx';
import { openAlert } from '../context/alert.js';
import { trackPageView } from '../util/Analytics.jsx';

const ResetPasswordPage = () => {
	trackPageView();

	const [, dispatch] = useStateValue();
	const params = useParams();

	const [password, setPassword] = useState('');
	const [repeatPassword, setRepeatPassword] = useState('');
	const [complete, setComplete] = useState(false);

	const id = params && 'id' in params ? params.id : false;
	const key = params && 'key' in params ? params.key : false;

	const passwordChange = e => {
		setPassword(e.target.value);
	};

	const repeatPasswordChange = e => {
		setRepeatPassword(e.target.value);
	};

	const formSubmit = e => {
		e.preventDefault();
		const postData = {
			id,
			verificationKey: key,
			password,
			repeatPassword
		};

		if (!postData.password || !postData.repeatPassword) {
			dispatch(openAlert('Passwords required', 'Please enter your password and repeat your password.'));
			return;
		}

		if (postData.password !== postData.repeatPassword) {
			dispatch(openAlert('Passwords mismatch', 'Your passwords must match.'));
			return;
		}

		Utils.ajax('resetPassword', postData, dispatch, () => {
			dispatch(openAlert('Success', 'Your password has been reset'));
			setComplete(true);
		});
	};

	if (id === false || key === false || complete) {
		return (<Navigate to="/signin" replace />);
	}
	return (
		<div className="resetPasswordPage">
			<div className="pageContent">
				<form className="signUpForm" onSubmit={formSubmit}>
					<h2>Password Reset</h2>
					<h3>Please enter a new password below to update your account:</h3>
					<div>
						<FormControl type="password" placeholder="New Password" onChange={passwordChange} />
					</div>
					<div>
						<FormControl type="password" placeholder="Repeat New Password" onChange={repeatPasswordChange} />
					</div>
					<div>
						<Button block bsStyle="primary" onClick={formSubmit}>Reset Password</Button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default ResetPasswordPage;
